import type { SelfEmployedWorkDetails } from '../../../api';

export interface SelfEmployedWorkFormValues {
  selfEmployedWorkDetails?: SelfEmployedWorkDetails;
}

export enum TypesSelfEmployment {
  OTHER = 'OTHER',
}
